import type { ReactNode } from 'react'
import { DetailHeading } from '../detail-heading/DetailHeading'
import type { DetailItemRow } from '../detail-item/DetailItem'
import { DetailHtmlValue } from './DetailHtmlValue'

type Params = {
  title: string
  tooltip?: ReactNode
  html: string
}

/**
 * Riadok detailu pre vlastný HTML text (BO Froala) — rovnaký layout ako ostatné riadky.
 * Pri dlhom texte sa heading zalomí a `HeadingText` (`w-full`) by odsunul tooltip ikonu
 * na okraj boxu — wrapper ju drží hneď za textom.
 */
export function customTextRow({ title, tooltip, html }: Params): DetailItemRow {
  return {
    heading: (
      <div className="[&>div>span]:w-auto">
        <DetailHeading title={title} tooltip={tooltip} />
      </div>
    ),
    value: <DetailHtmlValue html={html} />,
  }
}
